import React, { useState, useEffect } from "react";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";

import useScreenSize from "hooks/useScreenSize";
import { sizeEqualOrLessThan, getArticleCardHref } from "utils/helpers";
import SocialShareButton from "./SocialShareButton";
import BookmarkButton from "./BookmarkButton";
import CiteButton from "./CiteButton";
import GTM from "utils/GTM";
export default function SocialShareIcons(props) {
	const { article } = props;
	const { width, size } = useScreenSize();
	const [smOrSmaller, setSmOrSmaller] = useState(true);

	useEffect(() => {
		const smOrSmaller = sizeEqualOrLessThan("sm");
		setSmOrSmaller(smOrSmaller);
	}, [width, size]);

	return (
		<div className="social-share-container z-100">
			<SocialShareButton
				link={`https://twitter.com/intent/tweet?url=${encodeURI(
					`${process.env.WEB_URL}${getArticleCardHref(article.fields)}`
				)}&text=${encodeURI(article.fields.title)}&via=physicianalead`}
				smOrSmaller={smOrSmaller}
				text="Tweet"
				icon={faTwitter}
				className="Twitter-social-share social-share"
				gtmEvent={() => {
					GTM.socialShare({ platform: "Twitter", title: article.fields.title });
				}}
			/>

			<SocialShareButton
				link={`https://www.linkedin.com/shareArticle?url=${encodeURI(
					`${process.env.WEB_URL}${getArticleCardHref(article.fields)}`
				)}&title=${encodeURI(article.fields.title)}`}
				smOrSmaller={smOrSmaller}
				text="LinkedIn"
				icon={faLinkedin}
				className="LinkedIn-social-share social-share"
				gtmEvent={() => {
					GTM.socialShare({ platform: "LinkedIn", title: article.fields.title });
				}}
			/>
			{/* TODO: commented out bookmark feature */}
			<BookmarkButton article={article} />

			<CiteButton
				article={article}
				gtmEvent={() => {
					GTM.socialShare({ platform: "Citation", title: article.fields.title });
				}}
			/>

			<style jsx="true">{``}</style>
		</div>
	);
}
